<template>
  <!-- <h1>单位号</h1> -->
  <el-row>
    <el-form-item label="结算单位" prop="contract_info_pid" :rules="filter_rules()">
      <el-select v-model="info_pid" :disabled="modify" filterable remote placeholder="请选择结算单位" @focus="remoteMethod_name" @change="unitName">
        <el-option v-for="(item, index) in unitList" :key="index" :label="item.client_name" :value="item.contract_pid"></el-option>
      </el-select>
      <i class="iconfont icon-icon12 unit"></i>
    </el-form-item>
    <el-form-item label="指令单号" class="special" v-if="show">
      <el-select v-model="code" :disabled="modify" placeholder="请选择指令单号" @change="unitCode">
        <el-option v-for="(item, index) in instructList" :key="index" :label="item.instruct_code" :value="item.instruct_code"></el-option>
      </el-select>
    </el-form-item>
  </el-row>
</template>

<script>
import { isSuccess } from '@/assets/js/utils'
export default {
  data() {
    return {
      unitList: [],
      instructList: [],
      info_pid: this.infoPid, //合同pid
      client_name: this.infoName, //合同名称
      standard_rate: this.infoRate, //合同费率
      code: this.infoCode, //指令单号,
      modify: this.ifModify,
      show: this.isShow,
      payer: this.appointedP,
      owner_id: this.ownerId,
      unit_name: this.ownerUnit,
      is_show_rate: ''
    }
  },
  //   props: ['infoPid', 'infoCode', 'infoName', 'ifModify'],
  props: {
    infoPid: {
      required: false
    },
    infoCode: {
      required: false
    },
    infoName: {
      required: false
    },
    infoRate: {
      required: false
    },
    ifModify: {
      required: false
    },
    isShow: {
      required: false,
      default: true
    },
    appointedP: {
      required: false
    },
    ownerId: {
      required: false
    },
    ownerUnit: {
      required: false
    }
  },
  created() {
    console.log(this.ownerId)
  },
  watch: {
    infoPid: function(newVal, oldVal) {
      this.info_pid = newVal
      this.remoteMethod_name()
    },
    infoCode: function(newVal, oldVal) {
      this.code = newVal
    },
    infoName: function(newVal, oldVal) {
      this.client_name = newVal
    },
    infoRate: function(newVal, oldVal) {
      this.standard_rate = newVal
    },
    ifModify: function(newVal, oldVal) {
      this.modify = newVal
    },
    appointedP: function(newVal, oldVal) {
      this.payer = newVal
      this.unitList = []
      this.info_pid = ''
    },
    ownerId: function(newVal, oldVal) {
      this.owner_id = newVal
    },
    ownerUnit: function(newVal, oldVal) {
      this.unit_name = newVal
      this.unitList = []
      this.info_pid = ''
    }
  },
  methods: {
    remoteMethod_name() {
      this.unitList = []
      if (this.payer == 'Client' && this.owner_id != '') {
        api('waybill.client.name.batch.query', { pid: this.owner_id }).then((res) => {
          let data
          if ((data = isSuccess(res))) {
            this.unitList = data.response_list
            this.is_show_rate = data.is_show_rate
            if (this.is_show_rate == 'Yes') {
              this.unitList.forEach((item) => {
                let a = item.standard_rate * 100
                item.client_name = `${item.client_name}—${a.toFixed(2)}%`
              })
            }
          }
        })
      }
      if (this.payer != 'Client') {
        api('waybill.client.name.batch.query').then((res) => {
          let data
          if ((data = isSuccess(res))) {
            this.unitList = data.response_list
            this.is_show_rate = data.is_show_rate
            if (this.is_show_rate == 'Yes') {
              this.unitList.forEach((item) => {
                let a = item.standard_rate * 100
                item.client_name = `${item.client_name}—${a.toFixed(2)}%`
              })
            }
          }
        })
      }
    },
    unitName(val) {
      this.code = ''
      this.instructList = this.unitList.find((item) => {
        return item.contract_pid === val
      }).instruct_code_list
      this.standard_rate = this.unitList.find((item) => {
        return item.contract_pid === val
      }).standard_rate
      let is_car_fee = null
      this.unitList.forEach((item) => {
        if (val == item.contract_pid) {
          is_car_fee = item.is_car_fee
        }
      })
      this.$emit('getUnit', val, this.standard_rate, is_car_fee)
    },
    unitCode(val) {
      let pid = this.instructList.find((item) => {
        return item.instruct_code == val
      }).pid
      api('waybill.instruct.code.batch.query', { id: pid }).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          let obj = data
          let json = {
            val,
            obj
          }
          this.$emit('getCode', json)
        }
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/unitcode/unit-code.vue